// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1_OVE","cls2":"ResearchInterestTags-cls2_zbe ResearchInterestTags-cls1_OVE"};